import type { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { gatewayApiAccessTokenRequest } from '@/auth/config';
import { cacheGwApiAccessTokenResult } from '@/auth/GatewayApiAccessToken';

interface IGatewayApiSilentSsoResult {
  accessToken: string;
  expiresOn: number;
  account?: AccountInfo;
  username?: string;
}

export const acquireGwApiAccessTokenWithSilentSso = async (instance: IPublicClientApplication, loginHint: string): Promise<IGatewayApiSilentSsoResult> => {
  const response = await instance.ssoSilent({
    ...gatewayApiAccessTokenRequest,
    loginHint,
  });

  const token = cacheGwApiAccessTokenResult(response);

  return {
    accessToken: token.accessToken,
    expiresOn: token.expiresOn,
    account: response.account || undefined,
    username: response.account?.username,
  };
};

export const getGatewayApiAuthAccount = async (instance: IPublicClientApplication, loginHint: string): Promise<AccountInfo | undefined> => {
  const activeAccount = instance.getActiveAccount() || instance.getAllAccounts()[0];
  if (activeAccount) {
    return activeAccount;
  }

  // If there is a valid Entra session, recover the missing MSAL account for Gateway auth.
  const silentSsoResult = await acquireGwApiAccessTokenWithSilentSso(instance, loginHint);
  if (silentSsoResult.account) {
    return silentSsoResult.account;
  }
};
